import { defineStore } from 'pinia';

export const useCategoryStore = defineStore('category', {
  state: () => ({
    activeCategory: '',
  }),
  actions: {
    getActiveCategory() {
      return this.activeCategory;
    },
    setActiveCategory(category) {
      this.activeCategory = category;
    },
    resetVerifier() {
      this.activeCategory = '';
    },
  },
  persist: true,
});
